<template>
  <v-dialog v-model="updateCategory">
    <v-toolbar dense color="primary" dark>
      <v-toolbar-title>
        {{ $tc('action.buttons.updateInCascade') }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-text-field
          v-model.number="year"
          type="number"
          :label="$tc('titles.global.year')"
          :data-vv-name="$tc('titles.global.year')"
          :error-messages="errors.collect($tc('titles.global.year'))"
        />
      </v-card-text>
      <v-card-actions>
        <meta-button type="update" @click="submit()" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    updateCategory: Boolean,
  },
  data() {
    return {
      year: null,
    }
  },
  methods: {
    cancel() {
      this.$emit('close')
      this.year = null
    },
    submit() {
      this.$emit('updateInCascade', this.year)
      this.cancel()
    },
  },
}
</script>

<style></style>
